(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-the-blend"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {

  /* =========================================
     Blend Accordions
  ========================================= */

  document
    .querySelectorAll('.hoods-blend-accordion__button')
    .forEach(function (button) {

      button.addEventListener('click', function () {

        const accordion = button.closest('.hoods-blend-accordion');
        const isOpen = accordion.classList.contains('is-open');

        accordion.classList.toggle('is-open', !isOpen);

        button.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );

      });

    });


  /* =========================================
     Product Details - All Blends
  ========================================= */

  document
    .querySelectorAll('.hoods-blend-all__button')
    .forEach(function (button) {

      button.addEventListener('click', function () {

        const accordion = button.closest('.hoods-blend-all');
        const isOpen = accordion.classList.contains('is-open');

        accordion.classList.toggle('is-open', !isOpen);

        button.setAttribute(
          'aria-expanded',
          String(!isOpen)
        );

      });

    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
